import React from 'react';
import Tile from '../tile/tile';

const FilterResult = ({ hit, sendEvent }) => {
  const onClick = () => {
    sendEvent('click', hit, 'Article Clicked');
  };
  return (
    <div>
      <Tile
        onClick={() => onClick()}
        id={hit.id}
        tileType="standard"
        contentType={hit.pageType}
        url={hit.url}
        title={hit.listingTitle}
        description={hit.listingDescription}
        imageUrl={hit.file && hit.file.url}
        imageAlt={hit.title}
        resourceContentType={hit.resourceContentType?.map(r => r.title)}
        tags={hit.topics}
        tagLimit={3}
      />
    </div>
  );
};

export default FilterResult;
